import script from "./VUserSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./VUserSelector.vue?vue&type=script&setup=true&lang=ts"

import "./VUserSelector.vue?vue&type=style&index=0&id=2111be86&lang=scss"

const __exports__ = script;

export default __exports__